import { render, staticRenderFns } from "./AddJobItem.vue?vue&type=template&id=1dd51611"
import script from "./AddJobItem.vue?vue&type=script&lang=ts"
export * from "./AddJobItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports